import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import SupplierOverviewService from 'src/modules/3rd-party-management/apis/admin/SupplierOverviewService';

export const SUPPLIER_OVERVIEW_TASK_RISK_OVERVIEW_QUERY_KEY = '3rd-party-management-fetch-supplier-overview-task-risk-overview';

const useSupplierOverviewTaskRiskOverview = ({
    supplierId,
    t,
}) => {
    return useQuery({
        queryKey: [SUPPLIER_OVERVIEW_TASK_RISK_OVERVIEW_QUERY_KEY, supplierId],
        queryFn: async () => {
            const service = SupplierOverviewService.getInstance();

            return await service.fetchTaskRiskOverview(supplierId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: !!supplierId,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching dashboard data.'), {
                type: 'error',
            });
        },
    });
};

export default useSupplierOverviewTaskRiskOverview;
